export const themes = ({ isActive, hasIcon }) => ({
  default: {
    thRoot: `cursor-pointer flex flex-col sm:flex-row items-center p-5 rounded-4 text-12 text-black transition-colors duration-250 ease-in${
      isActive ? ' bg-saffron hocus:bg-saffron-active' : ' hocus:text-black-active'
    }`,
    thIcon: 'm-5 shrink-0',
    thIconWidth: '1.25rem',
    thLabel: hasIcon ? 'sr-only' : '',
  },
});
